import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Matches Button sizes: "default" 36px, "sm" 32px (pair with <Button size="sm">) */
  inputSize?: "default" | "sm";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex w-full rounded-md border border-input bg-background font-sans",
          inputSize === "sm" ? "h-8 px-2.5 py-1 text-xs" : "h-9 px-3 py-2 text-sm",
          // Placeholder
          "placeholder:text-muted-foreground/40",
          // Focus — animated border color using muted, no ring offset, no white outline
          "transition-colors duration-200",
          "focus:outline-none focus:border-muted-foreground",
          // Disabled
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
